import React from 'react';

import styled from 'styled-components';
import CheckboxSingle from '../CheckboxSingle';
import { colors } from '@/constants/colors';

interface Props {
   type: string;
   value: string;
   checkAll: boolean;
   handleCheckAll: () => void;
}

const HeadItem = ({ type, value, checkAll, handleCheckAll }: Props) => {
   return (
      <Wrapper>
         {type === 'title' && <Title>{value}</Title>}
         {type === 'checkbox' && (
            <div onClick={handleCheckAll}>
               <CheckboxSingle checked={checkAll} />
            </div>
         )}
         {type === 'empty' && <></>}
      </Wrapper>
   );
};
const Wrapper = styled.div``;
const Title = styled.p`
   font-weight: 500;
   font-size: 14px;
   color: ${colors.GRAY1};
`;

export default HeadItem;
